import React, { useMemo } from "react";
import "./Define.css";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { setState } from "./defineSlice";
import {
	biWeeklyDepCols,
	filterDepletionTypeColumnForScenario,
	getWeeklyDepColsForPeriodType,
	noDepCols,
	summaryView,
} from "./DefineQuotaBreakdownCols";
import {
	gridRowsAllBiweekly,
	gridRowsAllDepletionNone,
	depletionPeriodTypeShowsFiveWeeks,
} from "./defineUtils";

function DefineQuotaBreakdown() {
	const dispatch = useDispatch();
	const define = useSelector((state) => state.define);
	const {
		selectedRows,
		gridDataFiltered,
		selectedView,
		selectedDepletionPeriodType,
		selectedScenario,
	} = define;

	const scenarioPeriodType = selectedScenario?.periodType;

	const columns = useMemo(() => {
		let next;
		if (selectedView === 2) {
			next = summaryView;
		} else {
			const rows = gridDataFiltered ?? [];

			if (gridRowsAllDepletionNone(rows)) {
				next = noDepCols;
			} else if (gridRowsAllBiweekly(rows)) {
				next = biWeeklyDepCols;
			} else {
				const includeWeek5 = selectedDepletionPeriodType
					? depletionPeriodTypeShowsFiveWeeks(selectedDepletionPeriodType)
					: true;

				next = getWeeklyDepColsForPeriodType(includeWeek5);
			}
		}
		return filterDepletionTypeColumnForScenario(next, scenarioPeriodType);
	}, [
		selectedView,
		gridDataFiltered,
		selectedDepletionPeriodType,
		scenarioPeriodType,
	]);

	return (
		<Grid container direction="column" spacing={2}>
			<Grid item sx={{ width: "100%" }}>
				<DataGrid
					sx={{
						"& .MuiDataGrid-columnHeaderTitle": {
							whiteSpace: "normal",
							lineHeight: "normal",
						},
						"& .MuiDataGrid-columnHeader": {
							// Forced to use important since overriding inline styles
							height: "unset !important",
						},
						"& .MuiDataGrid-columnHeaders": {
							// Forced to use important since overriding inline styles
							maxHeight: "168px !important",
						},
					}}
					rows={gridDataFiltered}
					columns={columns}
					disableRowSelectionOnClick={true}
					checkboxSelection={true}
					onRowSelectionModelChange={(selRows) => {
						dispatch(setState("selectedRows", selRows));
					}}
					rowSelectionModel={selectedRows}
					disableColumnMenu
					disableColumnFilter
					disableColumnSelector
				/>
			</Grid>
		</Grid>
	);
}

export default DefineQuotaBreakdown;
